import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import Controller from './controller';

import Transition from '@ember/routing/-private/transition';
import DS from 'ember-data';

export default class SnippetsIndexRoute extends Route {
  @service store!: DS.Store;

  setupController(controller: Controller, model: unknown, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.setObjectTypeIds(controller.objectTypeIds);
    controller.fetchSnippets.perform();
  }

  resetController(controller: Controller, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setDefaults();
    }
  }
}
